/**
 * Hook to access app state from web application
 *
 * The web application passes its app state to the internal package via InternalContext.
 * This hook provides a convenient way to access that state.
 */

import { useInternalContext } from "../context/InternalContext";

/**
 * Hook to access the app state from web application
 * Returns the app state that was passed via InternalLayout
 */
export const useAppState = () => {
  const { appState } = useInternalContext();
  return appState;
};
